import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useInfluencerCheckout } from '../context/InfluencerCheckoutContext';
import { INSTA_TOOL_PLAN } from '../../insta-tools/data/instaToolPricing.config';

const UpgradePrompt = ({ title, description }) => {
  const { openCheckout } = useInfluencerCheckout();

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] px-6 py-12 text-center">
      <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center mb-4">
        <Lock className="w-7 h-7 text-gray-700" aria-hidden />
      </div>
      <h2 className="text-xl font-semibold mb-2">{title}</h2>
      <p className="text-gray-600 max-w-md mb-6">{description}</p>
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          type="button"
          onClick={() => openCheckout(INSTA_TOOL_PLAN)}
          className="bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition"
        >
          Upgrade to Premium — ₹99/mo
        </button>
        <Link
          to="/insta-tools/pricing"
          className="border border-black px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition"
        >
          View plans
        </Link>
      </div>
    </div>
  );
};

export default UpgradePrompt;
